'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.canMutate = canMutate;
exports['default'] = getImmutableOps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _lodashForOwn = require('lodash/forOwn');

var _lodashForOwn2 = _interopRequireDefault(_lodashForOwn);

var _lodashIsArrayLike = require('lodash/isArrayLike');

var _lodashIsArrayLike2 = _interopRequireDefault(_lodashIsArrayLike);

var _ramdaSrcCurry = require('ramda/src/curry');

var _ramdaSrcCurry2 = _interopRequireDefault(_ramdaSrcCurry);

var _ramdaSrcWrap = require('ramda/src/wrap');

var _ramdaSrcWrap2 = _interopRequireDefault(_ramdaSrcWrap);

var _ramdaSrc__ = require('ramda/src/__');

var _ramdaSrc__2 = _interopRequireDefault(_ramdaSrc__);

var MUTABILITY_TAG = '@@_______canMutate';

function fastArrayCopy(arr) {
    var copied = new Array(arr.length);
    for (var i = 0; i < arr.length; i++) {
        copied[i] = arr[i];
    }
    return copied;
}

function canMutate(obj) {
    return obj.hasOwnProperty(MUTABILITY_TAG);
}

function addCanMutateTag(opts, obj) {
    Object.defineProperty(obj, MUTABILITY_TAG, {
        value: true,
        configurable: true,
        enumerable: false
    });

    opts.batchManager.addMutated(obj);

    return obj;
}

function removeCanMutateTag(obj) {
    delete obj[MUTABILITY_TAG];
    return obj;
}

function prepareNewObject(opts, instance) {
    if (opts.batchManager.isWithMutations()) {
        addCanMutateTag(opts, instance);
    }
    opts.createdObjects++;
    return instance;
}

function forceArray(arg) {
    if (!(arg instanceof Array)) {
        return [arg];
    }
    return arg;
}

var PATH_SEPARATOR = '.';

function normalizePath(pathArg) {
    if (typeof pathArg === 'string') {
        if (pathArg.indexOf(PATH_SEPARATOR) === -1) {
            return [pathArg];
        }
        return pathArg.split(PATH_SEPARATOR);
    }

    return pathArg;
}

function mutableSet(opts, key, value, obj) {
    obj[key] = value;
    return obj;
}

function mutableSetIn(opts, _pathArg, value, obj) {
    var originalPathArg = normalizePath(_pathArg);

    var pathLen = originalPathArg.length;
    originalPathArg.reduce(function (acc, curr, idx) {
        if (idx === pathLen - 1) {
            acc[curr] = value;
            return value;
        }

        var currType = typeof acc[curr];

        if (currType === 'undefined') {
            var newObj = {};
            prepareNewObject(opts, newObj);
            acc[curr] = newObj;
            return newObj;
        }

        if (currType === 'object') {
            return acc[curr];
        }

        var pathRepr = originalPathArg[idx - 1] + '.' + curr;
        throw new Error('A non-object value was encountered when traversing setIn path at ' + pathRepr + '.');
    });

    return obj;
}

function valueInPath(opts, _pathArg, obj) {
    var pathArg = normalizePath(_pathArg);

    var acc = obj;
    for (var i = 0; i < pathArg.length; i++) {
        var curr = pathArg[i];
        var currRef = acc[curr];
        if (i === pathArg.length - 1) {
            return currRef;
        }

        if (typeof currRef === 'object') {
            acc = currRef;
        } else {
            return undefined;
        }
    }
}

function immutableSetIn(opts, _pathArg, value, obj) {
    var pathArg = normalizePath(_pathArg);

    var currentValue = valueInPath(opts, pathArg, obj);
    if (value === currentValue) return obj;

    var pathLen = pathArg.length;
    var acc = Object.assign(prepareNewObject(opts, {}), obj);
    var rootObj = acc;

    pathArg.forEach(function (curr, idx) {
        if (idx === pathLen - 1) {
            acc[curr] = value;
            return;
        }

        var currRef = acc[curr];
        var currType = typeof currRef;

        if (currType === 'object') {
            if (canMutate(currRef)) {
                acc = currRef;
            } else {
                var newObj = prepareNewObject(opts, {});
                acc[curr] = Object.assign(newObj, currRef);
                acc = newObj;
            }
            return;
        }

        if (currType === 'undefined') {
            var newObj = prepareNewObject(opts, {});
            acc[curr] = newObj;
            acc = newObj;
            return;
        }

        var pathRepr = pathArg[idx - 1] + '.' + curr;
        throw new Error('A non-object value was encountered when traversing setIn path at ' + pathRepr + '.');
    });

    return rootObj;
}

function mutableMerge(isDeep, opts, _mergeObjs, baseObj) {
    var mergeObjs = forceArray(_mergeObjs);

    if (opts.deep) {
        mergeObjs.forEach(function (mergeObj) {
            (0, _lodashForOwn2['default'])(mergeObj, function (value, key) {
                if (isDeep && baseObj.hasOwnProperty(key)) {
                    var assignValue = undefined;
                    if (typeof value === 'object') {
                        assignValue = canMutate(value) ? mutableMerge(isDeep, opts, [value], baseObj[key]) : immutableMerge(isDeep, opts, [value], baseObj[key]); // eslint-disable-line
                    } else {
                            assignValue = value;
                        }

                    baseObj[key] = assignValue;
                } else {
                    baseObj[key] = value;
                }
            });
        });
    } else {
        Object.assign.apply(Object, [baseObj].concat(_toConsumableArray(mergeObjs)));
    }

    return baseObj;
}

var mutableShallowMerge = mutableMerge.bind(null, false);
var mutableDeepMerge = mutableMerge.bind(null, true);

function mutableOmit(opts, _keys, obj) {
    var keys = forceArray(_keys);
    keys.forEach(function (key) {
        delete obj[key];
    });
    return obj;
}

function _shouldMergeKey(obj, other, key) {
    return obj[key] !== other[key];
}

function immutableMerge(isDeep, opts, _mergeObjs, obj) {
    if (canMutate(obj)) return mutableMerge(isDeep, opts, _mergeObjs, obj);
    var mergeObjs = forceArray(_mergeObjs);

    var hasChanges = false;
    var nextObject = obj;

    var willChange = function willChange() {
        if (!hasChanges) {
            hasChanges = true;
            nextObject = Object.assign({}, obj);
            prepareNewObject(opts, nextObject);
        }
    };

    mergeObjs.forEach(function (mergeObj) {
        (0, _lodashForOwn2['default'])(mergeObj, function (mergeValue, key) {
            if (isDeep && obj.hasOwnProperty(key)) {
                var currentValue = nextObject[key];
                if (typeof mergeValue === 'object' && !(mergeValue instanceof Array)) {
                    if (_shouldMergeKey(nextObject, mergeObj, key)) {
                        var recursiveMergeResult = immutableMerge(isDeep, opts, mergeValue, currentValue);

                        if (recursiveMergeResult !== currentValue) {
                            willChange();
                            nextObject[key] = recursiveMergeResult;
                        }
                    }
                    return true; // continue forOwn
                }
            }
            if (_shouldMergeKey(nextObject, mergeObj, key)) {
                willChange();
                nextObject[key] = mergeValue;
            }
        });
    });

    return nextObject;
}

var immutableDeepMerge = immutableMerge.bind(null, true);
var immutableShallowMerge = immutableMerge.bind(null, false);

function immutableArrSet(opts, index, value, arr) {
    if (canMutate(arr)) return mutableSet(opts, index, value, arr);

    if (arr[index] === value) return arr;

    var newArr = fastArrayCopy(arr);
    newArr[index] = value;
    prepareNewObject(opts, newArr);

    return newArr;
}

function immutableSet(opts, key, value, obj) {
    if ((0, _lodashIsArrayLike2['default'])(obj)) return immutableArrSet(opts, key, value, obj);
    if (canMutate(obj)) return mutableSet(opts, key, value, obj);

    if (obj[key] === value) return obj;

    var newObj = Object.assign({}, obj);
    prepareNewObject(opts, newObj);
    newObj[key] = value;
    return newObj;
}

function immutableOmit(opts, _keys, obj) {
    if (canMutate(obj)) return mutableOmit(opts, _keys, obj);

    var keys = forceArray(_keys);
    var keysInObj = keys.filter(function (key) {
        return obj.hasOwnProperty(key);
    });

    // None of the keys were in the object, so we can return `obj`.
    if (keysInObj.length === 0) return obj;

    var newObj = Object.assign({}, obj);
    keysInObj.forEach(function (key) {
        delete newObj[key];
    });
    prepareNewObject(opts, newObj);
    return newObj;
}

function mutableArrPush(opts, _vals, arr) {
    var vals = forceArray(_vals);
    arr.push.apply(arr, _toConsumableArray(vals));
    return arr;
}

function mutableArrFilter(opts, func, arr) {
    var currIndex = 0;
    var originalIndex = 0;
    while (currIndex < arr.length) {
        var item = arr[currIndex];
        if (!func(item, originalIndex)) {
            arr.splice(currIndex, 1);
        } else {
            currIndex++;
        }
        originalIndex++;
    }

    return arr;
}

function mutableArrSplice(opts, index, deleteCount, _vals, arr) {
    var vals = forceArray(_vals);
    arr.splice.apply(arr, [index, deleteCount].concat(_toConsumableArray(vals)));
    return arr;
}

function mutableArrInsert(opts, index, _vals, arr) {
    return mutableArrSplice(opts, index, 0, _vals, arr);
}

function immutableArrSplice(opts, index, deleteCount, _vals, arr) {
    if (canMutate(arr)) return mutableArrSplice(opts, index, deleteCount, _vals, arr);

    var vals = forceArray(_vals);
    var newArr = arr.slice();
    prepareNewObject(opts, newArr);
    newArr.splice.apply(newArr, [index, deleteCount].concat(_toConsumableArray(vals)));

    return newArr;
}

function immutableArrInsert(opts, index, _vals, arr) {
    if (canMutate(arr)) return mutableArrInsert(opts, index, _vals, arr);
    return immutableArrSplice(opts, index, 0, _vals, arr);
}

function immutableArrPush(opts, vals, arr) {
    return immutableArrInsert(opts, arr.length, vals, arr);
}

function immutableArrFilter(opts, func, arr) {
    if (canMutate(arr)) return mutableArrFilter(opts, func, arr);
    var newArr = arr.filter(func);

    if (newArr.length === arr.length) return arr;

    prepareNewObject(opts, newArr);
    return newArr;
}

var operations = {
    // object operations
    merge: immutableShallowMerge,
    deepMerge: immutableDeepMerge,
    omit: immutableOmit,
    setIn: immutableSetIn,

    // array operations
    insert: immutableArrInsert,
    push: immutableArrPush,
    filter: immutableArrFilter,
    splice: immutableArrSplice,

    // both
    set: immutableSet,

    mutable: {
        // object operations
        merge: mutableShallowMerge,
        deepMerge: mutableDeepMerge,
        omit: mutableOmit,
        setIn: mutableSetIn,

        // array operations
        insert: mutableArrInsert,
        push: mutableArrPush,
        filter: mutableArrFilter,
        splice: mutableArrSplice,

        // both
        set: mutableSet
    }
};

function bindOperationsToOptions(opsObj, opts) {
    var boundOperations = {};

    (0, _lodashForOwn2['default'])(opsObj, function (value, key) {
        if (typeof value === 'object') {
            boundOperations[key] = bindOperationsToOptions(value, opts);
        } else {
            boundOperations[key] = value.bind(null, opts);

            if (opts.curried) {
                boundOperations[key] = (0, _ramdaSrcCurry2['default'])(boundOperations[key]);
            }
        }
    });

    return boundOperations;
}

function getBatchManager() {
    var previousSessionStack = [];
    var currMutatedObjects = null;
    var objectsCreated = 0;

    return {
        open: function open() {
            if (currMutatedObjects !== null) {
                previousSessionStack.push(currMutatedObjects);
            }
            currMutatedObjects = [];
        },

        isWithMutations: function isWithMutations() {
            return currMutatedObjects !== null;
        },

        addMutated: function addMutated(obj) {
            currMutatedObjects.push(obj);
            objectsCreated++;
        },

        getMutatedObjects: function getMutatedObjects() {
            return currMutatedObjects;
        },

        getObjectsCreatedCount: function getObjectsCreatedCount() {
            return objectsCreated;
        },

        close: function close() {
            if (currMutatedObjects !== null) {
                currMutatedObjects.forEach(removeCanMutateTag);
                if (previousSessionStack.length) {
                    currMutatedObjects = previousSessionStack.pop();
                } else {
                    currMutatedObjects = null;
                }
                objectsCreated = 0;
            }
        }
    };
}

function getImmutableOps(userOpts) {
    var defaultOpts = {
        curried: true,
        batchManager: getBatchManager()
    };

    var opts = Object.assign({ createdObjects: 0 }, defaultOpts, userOpts || {});

    var boundOperations = bindOperationsToOptions(operations, opts);

    function batchWrapper() {
        var func = arguments[0];
        var args = Array.prototype.slice.call(arguments, 1);
        opts.batchManager.open();
        var returnValue = func.apply(null, args);
        opts.batchManager.close();
        return returnValue;
    }

    boundOperations.batched = batchWrapper;
    boundOperations.batch = (0, _ramdaSrcWrap2['default'])(_ramdaSrc__2['default'], batchWrapper);
    boundOperations.createdObjectsCount = function () {
        return opts.createdObjects;
    };
    boundOperations.getMutatedObjects = opts.batchManager.getMutatedObjects;
    boundOperations.__ = _ramdaSrc__2['default'];
    boundOperations.open = opts.batchManager.open;
    boundOperations.close = opts.batchManager.close;
    boundOperations.getBatchManager = getBatchManager;

    boundOperations.useBatchManager = function (manager) {
        opts.batchManager.close();
        opts.batchManager = manager;
        boundOperations.open = manager.open;
        boundOperations.close = manager.close;
        boundOperations.getMutatedObjects = manager.getMutatedObjects;
    };

    return boundOperations;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/immutable-ops/lib/index.js
 ** module id = 409
 ** module chunks = 0
 **/